export const initialRecoveryState = {
  tokenStatus: "UNKNOWN",
};
